/** @jsx jsx */
import { jsx } from '@emotion/core'
import { observer } from 'mobx-react'
import React, { Fragment, useState } from 'react'
import { isMobile } from 'react-device-detect'
// img
import { ChangeBtnIco } from '@shared/Icon/EtcIcon'
import { Button } from '@styles/button.style'
import { ModalBg } from '@styles/base.style'
import { Input, message, Form } from 'antd'
import { Modal } from 'antd-mobile'
import { FormComponentProps } from 'antd/lib/form'
import useRootStore from '@store/useRootStore'
import { showToast, TOAST_TYPE } from '@utils/utils'
import { AdvSlideUpModalStyle } from '@styles/modal'
import { NickContent } from './index.style'

interface NickDrawerProps extends FormComponentProps {
  visible: boolean
  setVisible: (arg: boolean) => void
}

const NickDrawer: React.FC<NickDrawerProps> = (props: NickDrawerProps) => {
  const { visible, setVisible, form } = props
  const { getFieldDecorator } = form
  const { authStore, userStore, globalStore } = useRootStore()
  const { signedin } = authStore
  const { userDetails } = userStore
  const [disabled, setDisabled] = useState(true)
  let validateNick = null

  const onChangeNick = e => {
    e.preventDefault()
    setDisabled(true)
  }
  const validatorCheckNick = (rules, value, callback) => {
    if (!value) {
      callback()
    } else if (value.length < 2 || value.length > 8) {
      callback()
    } else {
      callback(validateNick)
      validateNick = null
    }
  }
  const checkNick = async () => {
    const nickValue = form.getFieldValue('nick')
    if (nickValue.length >= 2 && nickValue.length <= 8) {
      await userStore.checkNick({ nick: nickValue })
      const { nick } = userStore
      if (nick.nick) {
        setDisabled(false)
        message.info('사용할 수 있는 닉네임 입니다.')
      } else {
        validateNick = '사용할수 없는 닉네임입니다.'
        form.validateFields(['nick'])
        message.error('사용할수 없는 닉네임입니다.')
      }
    }
  }

  const changeNick = async () => {
    if (disabled) {
      message.error('닉네임 확인을 해주세요.')
    } else {
      await userStore.changeNick({ nick: form.getFieldValue('nick') })
      const { nick } = userStore
      if (nick.nick) {
        await authStore.refreshSimpleUserInfo()
        setVisible(false)
        showToast(TOAST_TYPE.INFO, '닉네임 변경이 완료되었습니다.')
      } else {
        validateNick = '사용할수 없는 닉네임입니다. 다시 입력해 주세요.'
        form.validateFields(['nick'])
        message.error('사용할수 없는 닉네임입니다. 다시 입력해 주세요.')
      }
    }
  }

  const showChangeNickConfirmDialog = () => {
    globalStore.pushDialogYesNo({
      title: '닉네임 변경',
      text: ['닉네임 변경권이 1개 소진됩니다.', '변경하시겠습니까?'],
      className: 'small-size',
      positivePress: '변경',
      negativePress: '취소',
      callbackPositive: () => {
        changeNick()
      },
    })
  }

  if (signedin && !userDetails && visible) {
    userStore.getUserDetails({})
  }

  let nickChangeTit = null
  let elements = null

  if (userDetails) {

    nickChangeTit = (
      <Fragment>
        닉네임 변경
        <span className="sub-tit">(보유 닉네임 변경권 {userDetails.changeNickItem}개)</span>
      </Fragment>
    )

    elements = (
      <NickContent>
        <Form>
          <span className="change-txt">새 닉네임 입력</span>
          <Form.Item>
            {getFieldDecorator('nick', {
              rules: [
                { required: true, message: '닉네임을 입력해주세요.' },
                { min: 2, message: '2~8자까지 입력 가능합니다.' },
                { max: 8, message: '2~8자까지 입력 가능합니다.' },
                { validator: validatorCheckNick },
              ],
            })(<Input onChange={onChangeNick} placeholder="2~8자, 한글/영문/숫자 사용"/>)}
            <span className="line"/>
          </Form.Item>
          <Button onClick={checkNick} className="nickname-check-btn">
            중복 확인
          </Button>
        </Form>

        <Button secondary onClick={showChangeNickConfirmDialog} className="one-bottom-btn">
          <ChangeBtnIco/>
          변경하기
        </Button>
      </NickContent>
    )
  }

  if (elements) {
    globalStore.updateVisibleModalList(visible, 'NickDrawer:visible')
  }

  const onClickCloseButton = () => setVisible(false)

  return (
    <Fragment>
      <Modal
        popup
        visible={visible}
        maskClosable={false}
        animated={isMobile}
        animationType="slide-up"
        title={nickChangeTit}
        onClose={onClickCloseButton}
        className="short-top pc-close-btn-modal new-slide-modal"
        css={AdvSlideUpModalStyle}
      >
        {elements}
        <ModalBg onClick={onClickCloseButton}/>
      </Modal>
    </Fragment>
  )
}

export default Form.create<NickDrawerProps>()(observer(NickDrawer))
